/* eslint-disable class-methods-use-this */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { massMediaUrl, MASS_MEDIA_API } from 'SharedDir/backend/endpoints/mass-media';
import {
  MassMediaActualizationBare,
  MassMediaActualizationCreate,
  MassMediaActualizationUpdate,
  MassMediaBare,
  MassMediaCreate,
  MassMediaFull,
  MassMediaUpdate,
} from 'SharedDir/declarations/mass-media';
import fileDownloader from 'SharedDir/utils/file-downloader';

export default class MassMediaApiClass extends SimpleApi<
  MassMediaFull,
  MassMediaCreate,
  MassMediaUpdate,
  MassMediaBare
> {
  constructor() {
    super(massMediaUrl);
  }

  /**
   * Экспорт реестра СМИ
   * @returns {Promise<string>}
   */
  async exportRegistry() {
    const data = await http<string>({
      ...MASS_MEDIA_API.EXPORT_REGISTRY,
      responseType: 'blob',
    });
    fileDownloader.saveFileFromResponse(data);
    return data;
  }

  /**
   * Запрос на актуализацию всех СМИ в РКН
   */
  async actualizationRkn() {
    const data = await http(MASS_MEDIA_API.ACTUALIZATION.ACTUALIZATION_RKN);
    return data;
  }

  /**
   * Запрос на актуализацию конкретного СМИ в РКН
   */
  async actualizationRknSingle(id: number) {
    const data = await http(MASS_MEDIA_API.ACTUALIZATION.ACTUALIZATION_RKN_SINGLE(id));
    return data;
  }

  /**
   * Создание актуализация СМИ
   *
   * @param {MassMediaActualizationCreate} info
   * @returns {Promise<MassMediaActualizationBare>}
   */
  async actualizationStore(info: MassMediaActualizationCreate) {
    const { data } = (await http({
      ...MASS_MEDIA_API.ACTUALIZATION.ACTUALIZATION_STORE,
      data: info,
    })) as AxiosResponse<MassMediaActualizationBare>;
    return data;
  }

  /**
   * Создание актуализация СМИ
   *
   * @param {string | number} id
   * @param {MassMediaActualizationCreate} info
   * @returns {Promise<MassMediaActualizationBare>}
   */
  async actualizationDelete(id: string | number) {
    const { data } = (await http({
      ...MASS_MEDIA_API.ACTUALIZATION.ACTUALIZATION_DELETE(id),
    })) as AxiosResponse<MassMediaActualizationBare>;
    return data;
  }

  /**
   * Удаление актуализация СМИ
   *
   * @param {string | number} id
   * @param {MassMediaActualizationCreate} info
   * @returns {Promise<MassMediaActualizationBare>}
   */
  async actualizationUpdate(id: string | number, info: MassMediaActualizationUpdate) {
    const { data } = (await http({
      ...MASS_MEDIA_API.ACTUALIZATION.ACTUALIZATION_UPDATE(id),
      data: info,
    })) as AxiosResponse<MassMediaActualizationBare>;
    return data;
  }

  /**
   * Исключение из реестра СМИ
   *
   * @param {string | number} id
   * @returns {Promise<MassMediaFull>}
   */
  async exclude(id: string | number) {
    const { data } = (await http({
      ...MASS_MEDIA_API.EXCLUDE(id),
    })) as AxiosResponse<MassMediaFull>;
    return data;
  }

  /**
   * Восстановить исключенное СМИ в реестре
   *
   * @param {string | number} id
   * @returns {Promise<MassMediaFull>}
   */
  async restore(id: string | number) {
    const { data } = (await http({
      ...MASS_MEDIA_API.RESTORE(id),
    })) as AxiosResponse<MassMediaFull>;
    return data;
  }
}
